import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Quotation } from '../../models/quotation.model';
import { QuotationService } from '../../services/quotation.service';

@Component({
    selector: 'app-restore-quotation',
    templateUrl: './restore-quotation.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
/**
 * Create or update order popup component
 */
export class RestoreQuotationComponent {
  dialogRef = inject(MatDialogRef<RestoreQuotationComponent>);
  quotation: Quotation = inject(MAT_DIALOG_DATA);
  quotationService = inject(QuotationService);
  progress = false;
  error = null;

  /**
   * Close popup without any actions
   */
  cancel(): void {
    this.dialogRef.close();
  }

  /**
   * Create or update order
   */
  async restore(): Promise<void> {
    this.error = null;
    this.progress = true;
    try {
      const quotation = await this.quotationService.restoreQuotation(this.quotation);
      this.dialogRef.close(quotation)
    } catch (err) {
      console.error(err);
      this.error = err;
    } finally {
      this.progress = false
    }
  }
}
